







import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class AppPrintReport extends Vue {

    @Prop({required: true})
    public item: any;

    get url() {
        return `/admin/report?stockNumber=${this.item.stockNumber}`;
    }
}
